export const MAP_LAT_DEFAULT = 49.772530;
export const MAP_LONG_DEFAULT = 73.130004;
